export function Box(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.8325 3.67923C20.6492 3.95146 21.2001 4.71573 21.2001 5.57659V16.4234C21.2001 17.2842 20.6492 18.0485 19.8325 18.3207L11.6325 21.0541C11.222 21.1909 10.7781 21.1909 10.3676 21.0541L2.16759 18.3207C1.35091 18.0485 0.800049 17.2842 0.800049 16.4234V5.5766C0.800049 4.71573 1.35091 3.95146 2.16759 3.67923L10.3676 0.945895C10.7781 0.809051 11.222 0.809051 11.6325 0.945896L19.8325 3.67923ZM11 3.2649L3.54473 5.75001L5.50929 6.40486C5.53991 6.39118 5.57136 6.37866 5.60359 6.36738L12.7762 3.85696L11 3.2649ZM16.4908 5.09514C16.4601 5.10883 16.4287 5.12135 16.3964 5.13264L9.22385 7.64304L10.747 8.15075C10.9112 8.20549 11.0887 8.20549 11.2529 8.15075L18.4553 5.74997L16.4908 5.09514ZM3.20005 16.1351V8.16493L9.80005 10.3649V18.3351L3.20005 16.1351ZM12.2 18.3351V10.3649L18.8 8.16487V16.1351L12.2 18.3351Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
